export default __webpack_public_path__ + "static/ux-ui-hero-cc4cc1a9dae04fe76fd2c27ca1f0af2c.png";